module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center mb-1"
  }, [_c('h2', {
    staticClass: "m-0"
  }, [_vm._v(_vm._s(_vm.headerLine1))]), _vm._v(" "), _c('change-status-btn', {
    staticClass: "ml-2",
    attrs: {
      "disabled": _vm.getIsSavingReservation || _vm.accessPermissionFilter(['restricted'])
    },
    model: {
      value: (_vm.reservation),
      callback: function($$v) {
        _vm.reservation = $$v
      },
      expression: "reservation"
    }
  }), _vm._v(" "), (!_vm.getIsLoadingCalculations) ? _c('payment-status-btn', {
    staticClass: "ml-2",
    attrs: {
      "reservation": _vm.reservation
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('h3', {
    staticClass: "mb-1 light"
  }, [_vm._v(_vm._s(_vm.headerLine2))]), _vm._v(" "), (_vm.reservation.lastUpdatedBy && _vm.reservation.lastUpdatedDate) ? _c('h3', {
    staticClass: "mb-1 light"
  }, [_vm._v(_vm._s(_vm.headerLine3))]) : _vm._e(), _vm._v(" "), _c('connected-reservations', {
    attrs: {
      "reservation": _vm.reservation
    }
  }), _vm._v(" "), (_vm.reservation.status === -5 && _vm.filteredCancellationReasons.length > 0) ? _c('div', {
    staticClass: "cancellationReason"
  }, [_c('span', {
    staticClass: "mr-1 font-weight-400"
  }, [_vm._v("Canceled at " + _vm._s(_vm.formattedCancellationDate) + " - ")]), _vm._v(" "), (_vm.editMode && _vm.reservation.cancelationReasonId !== null && _vm.cancelationReasonIdIsNullButIsToOpenDropBox) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.cancellationReasonObject && _vm.cancellationReasonObject.description ? _vm.cancellationReasonObject.description : _vm.reservation.cancelationNote),
      expression: "cancellationReasonObject && cancellationReasonObject.description ? cancellationReasonObject.description : reservation.cancelationNote"
    }],
    staticClass: "col-sm-3"
  }, [(_vm.filteredCancellationReasons.length > 0) ? _c('v-select', {
    staticClass: "title-area__dropdown darker radius-normal",
    attrs: {
      "id": "cancellationReason",
      "options": _vm.filteredCancellationReasons,
      "reduce": function (reason) { return reason.id; },
      "label": "description",
      "placeholder": "Select a reason"
    },
    on: {
      "input": function($event) {
        return _vm.updateCancellationReason(_vm.cancellationReasonObject)
      }
    },
    model: {
      value: (_vm.cancellationReasonObject),
      callback: function($$v) {
        _vm.cancellationReasonObject = $$v
      },
      expression: "cancellationReasonObject"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.cancelationReasonIdIsNullButIsToOpenDropBox) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.cancellationReasonObject && _vm.cancellationReasonObject.description ? _vm.cancellationReasonObject.description : _vm.reservation.cancelationNote),
      expression: "cancellationReasonObject && cancellationReasonObject.description ? cancellationReasonObject.description : reservation.cancelationNote"
    }],
    staticClass: "col-sm-3"
  }, [(_vm.filteredCancellationReasons.length > 0) ? _c('v-select', {
    staticClass: "title-area__dropdown darker radius-normal",
    attrs: {
      "id": "cancellationReason",
      "options": _vm.filteredCancellationReasons,
      "reduce": function (reason) { return reason.id; },
      "label": "description",
      "placeholder": "Select a reason"
    },
    on: {
      "input": function($event) {
        return _vm.updateCancellationReason(_vm.cancellationReasonObject)
      }
    },
    model: {
      value: (_vm.cancellationReasonObject),
      callback: function($$v) {
        _vm.cancellationReasonObject = $$v
      },
      expression: "cancellationReasonObject"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.editMode) ? _c('span', {
    staticClass: "lightest radius-normal py-1"
  }, [(_vm.userClickedOptionOther) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.cancelationNote),
      expression: "reservation.cancelationNote"
    }],
    ref: "cancelationNote",
    staticClass: "compactInput",
    attrs: {
      "type": "text",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.reservation.cancelationNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "cancelationNote", $event.target.value)
      }
    }
  })]) : _c('span', [(_vm.cancellationReasonObject && _vm.cancellationReasonObject.id) ? _c('span', [_vm._v(_vm._s(_vm.cancellationReasonObject.description))]) : _c('span', [(!!_vm.reservation.cancelationNote) ? _c('span', [_vm._v(_vm._s(_vm.reservation.cancelationNote))]) : _c('span', [_vm._v("Reason not specified")])])])]) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.cancellationReasonObject && _vm.cancellationReasonObject.id === null) ? _c('span', [(_vm.cancelationReasonIdIsNullButIsToOpenDropBox) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.cancelationNote),
      expression: "reservation.cancelationNote"
    }],
    ref: "cancelationNote",
    staticClass: "compactInput",
    attrs: {
      "type": "text",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.reservation.cancelationNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "cancelationNote", $event.target.value)
      }
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.reservation.cancelationNote))])]) : _vm._e(), _vm._v(" "), (!_vm.editMode && !_vm.userClickedOptionOther) ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.enterEditMode.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "mr-0 ml-2 ico ico-edit"
  })]) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.cancellationReasonObject && _vm.cancellationReasonObject.id === null && !_vm.cancelationReasonIdIsNullButIsToOpenDropBox) ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editCancelationNoteDirectly.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "mr-0 ml-2 ico ico-edit"
  })]) : _vm._e(), _vm._v(" "), (!_vm.editMode && _vm.userClickedOptionOther || _vm.editMode && _vm.cancellationReasonObject && _vm.cancellationReasonObject.id === null) ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.saveEditOtherReason.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fas ml-2 mr-0 fa-save"
  })]) : _vm._e(), _vm._v(" "), (_vm.editMode || _vm.userClickedOptionOther) ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelEdit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "mr-0 ml-2 ico ico-close"
  })]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5e0d7faf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e0d7faf"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TitleArea.vue
// module id = 1890
// module chunks = 0